var _defs, _line, _text, _g, _line2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAboutVerticalLineEn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 111,
    height: 612.623,
    viewBox: "0 0 111 612.623",
    className: "history-section__year-svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Polygon_8",
    x: 29.672,
    y: 79.122,
    width: 58.656,
    height: 52.496,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    id: "Line_69",
    "data-name": "Line 69",
    y1: 142,
    transform: "translate(59.411)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 3,
    strokeDasharray: "7 9",
    opacity: 0.664
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    id: "_2018",
    "data-name": 2018,
    transform: "translate(90 481.123) rotate(-90)",
    fill: "#fff",
    fontSize: 83,
    fontFamily: "SegoeUI, Segoe UI",
    opacity: 0.827
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 100,
    y: 0,
    className: "bold"
  }, "2018"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 0, 0)",
    filter: "url(#Polygon_8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Polygon_8-2",
    "data-name": "Polygon 8",
    d: "M17.744,4.386a3,3,0,0,1,5.169,0L37.991,29.973A3,3,0,0,1,35.406,34.5H5.25a3,3,0,0,1-2.585-4.523Z",
    transform: "translate(79.33 119.62) rotate(180)",
    fill: "#e1591f"
  }))), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    id: "Line_70",
    "data-name": "Line 70",
    y1: 205,
    transform: "translate(58.955 407.623)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 3,
    strokeDasharray: "7 9",
    opacity: 0.664
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutVerticalLineEn);
export default __webpack_public_path__ + "static/media/aboutVerticalLineEn.0905a5f734d6def62b13074ce33526a5.svg";
export { ForwardRef as ReactComponent };